import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=94274fc8&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"
import style0 from "./studentList.vue?vue&type=style&index=0&id=94274fc8&prod&lang=less&scoped=true"
import style1 from "./studentList.vue?vue&type=style&index=1&id=94274fc8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94274fc8",
  null
  
)

export default component.exports